module.exports = __webpack_public_path__ + "img/1.ab9b7621.png";